<template>
  <div class="">
    <font-awesome-icon v-for="icon in icons" :key="icon.iconName" :icon="icon" class="m-2" @click="select(icon.iconName)" />
  </div>
</template>

<script>
import { departmentIcons } from '@/fontAwesome';
export default {
  name: 'iconPicker',
  data() {
    return {
      icons: departmentIcons,
    };
  },
  methods: {
    select(value) {
      this.$emit('input', value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/misc/iconPicker.vue